import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=2ba9d7c5"
var script = {}
import style0 from "./logo.vue?vue&type=style&index=0&id=2ba9d7c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports